import { observer } from "mobx-react";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export default observer(function RemoveAllFavoritesTournamentsButton() {
	const favoritesStore = useContext(FavoritesStoreContext);
	const { t } = useTranslation();
	const location = useLocation();

	if (!favoritesStore) {
		return null;
	}
	if (
		!location.pathname.includes("my-favorites/tournaments") ||
		favoritesStore.favoriteTournamentsCount == 0
	) {
		return null;
	}

	return (
		<div className="pagination__remove">
			<button
				className="pagination__remove__btn btn btn--sml btn--ghost--danger"
				type="button"
				onClick={favoritesStore.deselectFavoritesTournaments}
			>
				{t("FAVORITES.REMOVE_ALL_FAVORITES")}
			</button>
		</div>
	);
});
